import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { supabase } from '../services/supabase';

export default function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      // Return to wherever the reader was headed (an emailed document link,
      // say). Relative paths only, so the parameter cannot bounce them to
      // another site. Otherwise route through the index gate so each role lands
      // on the right home.
      const redirect = searchParams.get('redirect') || '';
      const safe = redirect.startsWith('/') && !redirect.startsWith('//');
      navigate(safe ? redirect : '/');
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: '#F5F6F8',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '0 24px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{
            width: '44px', height: '44px', background: '#0A1628',
            borderRadius: '10px', display: 'flex', alignItems: 'center',
            justifyContent: 'center', margin: '0 auto 16px',
            fontSize: '20px', fontWeight: 700, color: '#FFFFFF'
          }}>A</div>
          <h1 style={{ fontFamily: 'Georgia, serif', fontWeight: 400, fontSize: '28px', color: '#0A0A0A', marginBottom: '6px' }}>
            Welcome back
          </h1>
          <p style={{ fontSize: '14px', color: '#6B7280' }}>Sign in to your Altveno account</p>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin}>
          {error && (
            <div style={{
              background: '#FDF6E7', border: '1px solid #D0D5DD',
              borderRadius: '4px', padding: '12px 14px', marginBottom: '16px',
              fontSize: '13px', color: '#C0222A'
            }}>{error}</div>
          )}

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', fontSize: '12px', color: '#6B7280', marginBottom: '6px' }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@altveno.com"
              required
              style={{
                width: '100%', background: '#FFFFFF',
                border: '1px solid #D0D5DD',
                borderRadius: '3px', color: '#0A0A0A',
                fontSize: '14px', padding: '10px 14px', outline: 'none',
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', fontSize: '12px', color: '#6B7280', marginBottom: '6px' }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={{
                width: '100%', background: '#FFFFFF',
                border: '1px solid #D0D5DD',
                borderRadius: '3px', color: '#0A0A0A',
                fontSize: '14px', padding: '10px 14px', outline: 'none',
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', background: '#0A1628',
              border: 'none', borderRadius: '3px',
              color: '#FFFFFF', fontSize: '14px', fontWeight: 600,
              padding: '11px', cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: 'system-ui, -apple-system, sans-serif',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <p style={{ textAlign: 'center', fontSize: '13px', color: '#6B7280', marginTop: '24px' }}>
          Don't have an account?{' '}
          <Link to="/register" style={{ color: '#C9A84C', textDecoration: 'none' }}>
            Create one
          </Link>
        </p>
      </div>
    </div>
  );
}